export enum OrderItemEventStatus {
	ALL = 'all',
	GOING_ON = 'going_on',
	TODAY = 'today',
	COMING = 'coming',
	HAPPENED = 'happened'
}
